var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"nav"}},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")]),_vm._v(" | "),_c('router-link',{attrs:{"to":"/about"}},[_vm._v("About")]),_vm._v(" | "),_c('router-link',{attrs:{"to":"/side"}},[_vm._v("Side")]),_vm._v(" | ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }